import React, { useState } from 'react';
import TabBody from '../../components/tab-components/TabBody';
import TabHeader from '../../components/tab-components/TabHeader';
import TabLayout from '../../components/tab-components/TabLayout';
import AuthorizeError from 'pages/AuthorizeError';
import { UserTabsList } from './utils';
import { permissionKeys } from 'config/config';
import { isPermissionAvailable } from 'config/permissionUtils';
import UserList from './UserList';
import GuestUsersList from './guest/GuestUsersList';

const Users = () => {
  const [hasPermissionToAccess] = useState(
    isPermissionAvailable(permissionKeys.employees_users_read),
  );
  const [selectedTab, setSelectedTab] = useState(UserTabsList[0]);

  return (
    <>
      {!hasPermissionToAccess ? (
        <AuthorizeError />
      ) : (
        <>
          <TabLayout>
            <TabHeader
              tabList={UserTabsList}
              selectedTab={selectedTab}
              setSelectedTab={setSelectedTab}
            />
            <TabBody>
              {['user', 'admin', 'pending', 'archived'].includes(selectedTab.value) ? (
                <UserList selectedTab={selectedTab} />
              ) : (
                <GuestUsersList />
              )}
            </TabBody>
          </TabLayout>
        </>
      )}
    </>
  );
};

export default Users;
